export default __webpack_public_path__ + "static/tokenomics-02b8958755cc3a17d16b12a552ed05ac.png";